const actions = {
  GET_INVENTORY_SETTINGS_REQUEST: 'GET_INVENTORY_SETTINGS_REQUEST',
  GET_INVENTORY_SETTINGS_SUCCESS: 'GET_INVENTORY_SETTINGS_SUCCESS',
  GET_INVENTORY_SETTINGS_ERROR: 'GET_INVENTORY_SETTINGS_ERROR',
  CHANGE_INVENTORY_INVOICE_AUTOMATION_REQUEST: 'CHANGE_INVENTORY_INVOICE_AUTOMATION_REQUEST',
  CHANGE_INVENTORY_INVOICE_AUTOMATION_ERROR: 'CHANGE_INVENTORY_INVOICE_AUTOMATION_ERROR',
  CHANGE_INVENTORY_SHOW_FINALIZED_APPOINTMENT_MODAL_REQUEST: 'CHANGE_INVENTORY_SHOW_FINALIZED_APPOINTMENT_MODAL_REQUEST',
  CHANGE_INVENTORY_SHOW_FINALIZED_APPOINTMENT_MODAL_ERROR: 'CHANGE_INVENTORY_SHOW_FINALIZED_APPOINTMENT_MODAL_ERROR',
  INVENTORY_ITEMS_LISTENER_REQUEST: 'INVENTORY_ITEMS_LISTENER_REQUEST',
  INVENTORY_ITEMS_FETCH_SUCCESS: 'INVENTORY_ITEMS_FETCH_SUCCESS',
  INVENTORY_ITEMS_BATCHES_FETCH_SUCCESS: 'INVENTORY_ITEMS_BATCHES_FETCH_SUCCESS',
  RESET_INVENTORY_LISTENER: 'RESET_INVENTORY_LISTENER',
  INVENTORY_FETCH_REQUEST: 'INVENTORY_FETCH_REQUEST',
  INVENTORY_FETCH_ERROR: 'INVENTORY_FETCH_ERROR',
  INVENTORY_OPS_FETCH_REQUEST: 'INVENTORY_OPS_FETCH_REQUEST',
  INVENTORY_OPS_FETCH_SUCCESS: 'INVENTORY_OPS_FETCH_SUCCESS',
  INVENTORY_OPS_FETCH_ERROR: 'INVENTORY_OPS_FETCH_ERROR',
  RESET_INVENTORY_OPS: 'RESET_INVENTORY_OPS',
  FETCHING_INVENTORY_OPS_LIST: 'FETCHING_INVENTORY_OPS_LIST',
  INVENTORY_PROVIDERS_FETCH_REQUEST: 'INVENTORY_PROVIDERS_FETCH_REQUEST',
  INVENTORY_PROVIDERS_FETCH_SUCCESS: 'INVENTORY_PROVIDERS_FETCH_SUCCESS',
  INVENTORY_CLASSES_FETCH_REQUEST: 'INVENTORY_CLASSES_FETCH_REQUEST',
  INVENTORY_CLASSES_FETCH_SUCCESS: 'INVENTORY_CLASSES_FETCH_SUCCESS',
  CREATE_INVENTORY_ITEM_REQUEST: 'CREATE_INVENTORY_ITEM_REQUEST',
  CREATE_INVENTORY_ITEM_SUCCESS: 'CREATE_INVENTORY_ITEM_SUCCESS',
  CREATE_INVENTORY_ITEM_ERROR: 'CREATE_INVENTORY_ITEM_ERROR',
  INVENTORY_FETCH_OR_UPDATING_WAITING: 'INVENTORY_FETCH_OR_UPDATING_WAITING',
  REMOVE_INVENTORY_ITEM_REQUEST: 'REMOVE_INVENTORY_ITEM_REQUEST',
  REMOVE_INVENTORY_ITEM_SUCCESS: 'REMOVE_INVENTORY_ITEM_SUCCESS',
  REMOVE_INVENTORY_ITEM_ERROR: 'REMOVE_INVENTORY_ITEM_ERROR',
  DEPOSIT_INVENTORY_ITEM_REQUEST: 'DEPOSIT_INVENTORY_ITEM_REQUEST',
  DEPOSIT_INVENTORY_ITEM_SUCCESS: 'DEPOSIT_INVENTORY_ITEM_SUCCESS',
  DEPOSIT_INVENTORY_ITEM_ERROR: 'DEPOSIT_INVENTORY_ITEM_ERROR',
  CREATE_INVENTORY_PROVIDER_REQUEST: 'CREATE_INVENTORY_PROVIDER_REQUEST',
  CREATE_INVENTORY_PROVIDER_SUCCESS: 'CREATE_INVENTORY_PROVIDER_SUCCESS',
  CREATE_INVENTORY_PROVIDER_ERROR: 'CREATE_INVENTORY_PROVIDER_ERROR',
  REMOVE_INVENTORY_PROVIDER_REQUEST: 'REMOVE_INVENTORY_PROVIDER_REQUEST',
  REMOVE_INVENTORY_PROVIDER_SUCCESS: 'REMOVE_INVENTORY_PROVIDER_SUCCESS',
  REMOVE_INVENTORY_PROVIDER_ERROR: 'REMOVE_INVENTORY_PROVIDER_ERROR',
  INVENTORY_REMOVE_PROVIDER_WAITING: 'INVENTORY_REMOVE_PROVIDER_WAITING',
  UPDATE_INVENTORY_PROVIDER_REQUEST: 'UPDATE_INVENTORY_PROVIDER_REQUEST',
  UPDATE_INVENTORY_PROVIDER_ERROR: 'UPDATE_INVENTORY_PROVIDER_ERROR',
  PROVIDER_HISTORY_FETCH_REQUEST: 'PROVIDER_HISTORY_FETCH_REQUEST',
  PROVIDER_HISTORY_FETCH_SUCCESS: 'PROVIDER_HISTORY_FETCH_SUCCESS',
  PROVIDER_HISTORY_FETCH_ERROR: 'PROVIDER_HISTORY_FETCH_ERROR',
  PROVIDER_HISTORY_CLEAR: 'PROVIDER_HISTORY_CLEAR',
  WITHDRAW_INVENTORY_ITEM_REQUEST: 'WITHDRAW_INVENTORY_ITEM_REQUEST',
  WITHDRAW_INVENTORY_ITEM_SUCCESS: 'WITHDRAW_INVENTORY_ITEM_SUCCESS',
  WITHDRAW_INVENTORY_ITEM_ERROR: 'WITHDRAW_INVENTORY_ITEM_ERROR',
  UPDATE_INVENTORY_DEPOSIT_REQUEST: 'UPDATE_INVENTORY_DEPOSIT_REQUEST',
  UPDATE_INVENTORY_DEPOSIT_SUCCESS: 'UPDATE_INVENTORY_DEPOSIT_SUCCESS',
  UPDATE_INVENTORY_DEPOSIT_ERROR: 'UPDATE_INVENTORY_DEPOSIT_ERROR',
  CANCEL_OPERATION_REQUEST: 'CANCEL_OPERATION_REQUEST',
  CANCEL_OPERATION_SUCCESS: 'CANCEL_OPERATION_SUCCESS',
  CANCEL_OPERATION_ERROR: 'CANCEL_OPERATION_ERROR',
  CANCEL_OPERATION_WAITING: 'CANCEL_OPERATION_WAITING',
  UPDATE_INVENTORY_WITHDRAW_REQUEST: 'UPDATE_INVENTORY_WITHDRAW_REQUEST',
  UPDATE_INVENTORY_WITHDRAW_SUCCESS: 'UPDATE_INVENTORY_WITHDRAW_SUCCESS',
  UPDATE_INVENTORY_WITHDRAW_ERROR: 'UPDATE_INVENTORY_WITHDRAW_ERROR',
  CREATE_INVENTORY_CLASS_REQUEST: 'CREATE_INVENTORY_CLASS_REQUEST',
  CREATE_INVENTORY_CLASS_SUCCESS: 'CREATE_INVENTORY_CLASS_SUCCESS',
  CREATE_INVENTORY_CLASS_ERROR: 'CREATE_INVENTORY_CLASS_ERROR',
  REMOVE_INVENTORY_CLASS_REQUEST: 'REMOVE_INVENTORY_CLASS_REQUEST',
  REMOVE_INVENTORY_CLASS_SUCCESS: 'REMOVE_INVENTORY_CLASS_SUCCESS',
  REMOVE_INVENTORY_CLASS_ERROR: 'REMOVE_INVENTORY_CLASS_ERROR',
  UPDATE_INVENTORY_CLASS_REQUEST: 'UPDATE_INVENTORY_CLASS_REQUEST',
  UPDATE_INVENTORY_CLASS_SUCCESS: 'UPDATE_INVENTORY_CLASS_SUCCESS',
  UPDATE_INVENTORY_CLASS_ERROR: 'UPDATE_INVENTORY_CLASS_ERROR',
  UPDATE_INVENTORY_ITEM_REQUEST: 'UPDATE_INVENTORY_ITEM_REQUEST',
  UPDATE_INVENTORY_ITEM_SUCCESS: 'UPDATE_INVENTORY_ITEM_SUCCESS',
  UPDATE_INVENTORY_ITEM_ERROR: 'UPDATE_INVENTORY_ITEM_ERROR',
  UPDATE_FINALIZED_APPOINTMENT_PROCEDURES_ARR_FROM_INVENTORY_REQUEST: 'UPDATE_FINALIZED_APPOINTMENT_PROCEDURES_ARR_FROM_INVENTORY_REQUEST',
  UPDATE_FINALIZED_APPOINTMENT_PROCEDURES_ARR_FROM_INVENTORY_SUCCESS: 'UPDATE_FINALIZED_APPOINTMENT_PROCEDURES_ARR_FROM_INVENTORY_SUCCESS',
  UPDATE_FINALIZED_APPOINTMENT_PROCEDURES_ARR_FROM_INVENTORY_ERROR: 'UPDATE_FINALIZED_APPOINTMENT_PROCEDURES_ARR_FROM_INVENTORY_ERROR',
  SAVING_FINALIZED_APPOINTMENT_FROM_INVENTORY: 'SAVING_FINALIZED_APPOINTMENT_FROM_INVENTORY',
  CHANGE_INVENTORY_OPS_LISTENER_TIMER: 'CHANGE_INVENTORY_OPS_LISTENER_TIMER',
  SAVE_ITEM_SELL_VALUE_REQUEST: 'SAVE_ITEM_SELL_VALUE_REQUEST',
  SAVE_ITEM_SELL_VALUE_SUCCESS: 'SAVE_ITEM_SELL_VALUE_SUCCESS',
  SAVE_ITEM_SELL_VALUE_ERROR: 'SAVE_ITEM_SELL_VALUE_ERROR',
  SAVING_ITEM_SELL_VALUE: 'SAVING_ITEM_SELL_VALUE',
  WAITING_INVENTORY_OPS: 'WAITING_INVENTORY_OPS',
  INVENTORY_WAREHOUSES_FETCH_SUCCESS: 'INVENTORY_WAREHOUSES_FETCH_SUCCESS',
  INVENTORY_NEW_BATCHES_FETCH_SUCCESS: 'INVENTORY_NEW_BATCHES_FETCH_SUCCESS',
  INVENTORY_STOCK_FETCH_SUCCESS: 'INVENTORY_STOCK_FETCH_SUCCESS',
  CREATE_WAREHOUSE_REQUEST: 'CREATE_WAREHOUSE_REQUEST',
  CREATE_WAREHOUSE_SUCCESS: 'CREATE_WAREHOUSE_SUCCESS',
  CREATE_WAREHOUSE_ERROR: 'CREATE_WAREHOUSE_ERROR',
  CREATING_WAREHOUSE: 'CREATING_WAREHOUSE',
  UPDATE_WAREHOUSE_REQUEST: 'UPDATE_WAREHOUSE_REQUEST',
  UPDATE_WAREHOUSE_SUCCESS: 'UPDATE_WAREHOUSE_SUCCESS',
  UPDATE_WAREHOUSE_ERROR: 'UPDATE_WAREHOUSE_ERROR',
  UPDATING_WAREHOUSE: 'UPDATING_WAREHOUSE',
  TRANSFER_INVENTORY_REQUEST: 'TRANSFER_INVENTORY_REQUEST',
  TRANSFER_INVENTORY_SUCCESS: 'TRANSFER_INVENTORY_SUCCESS',
  TRANSFER_INVENTORY_ERROR: 'TRANSFER_INVENTORY_ERROR',
  UPDATE_TRANSFER_INVENTORY_REQUEST: 'UPDATE_TRANSFER_INVENTORY_REQUEST',
  getInventorySettings: () => ({
    type: actions.GET_INVENTORY_SETTINGS_REQUEST,
  }),
  changeInvoiceAutomation: (value) => ({
    type: actions.CHANGE_INVENTORY_INVOICE_AUTOMATION_REQUEST,
    payload: value,
  }),
  changeShowFinalizedAppointmentModal: (value) => ({
    type: actions.CHANGE_INVENTORY_SHOW_FINALIZED_APPOINTMENT_MODAL_REQUEST,
    payload: value,
  }),
  getInventoryLitener: () => ({
    type: actions.INVENTORY_ITEMS_LISTENER_REQUEST,
  }),
  getInventory: () => ({
    type: actions.INVENTORY_FETCH_REQUEST,
  }),
  createInventoryItem: (item) => ({
    type: actions.CREATE_INVENTORY_ITEM_REQUEST,
    payload: item,
  }),
  removeInventoryItem: (key) => ({
    type: actions.REMOVE_INVENTORY_ITEM_REQUEST,
    payload: key,
  }),
  depositInventoryItem: (values) => ({
    type: actions.DEPOSIT_INVENTORY_ITEM_REQUEST,
    payload: values,
  }),
  createInventoryProvider: (item) => ({
    type: actions.CREATE_INVENTORY_PROVIDER_REQUEST,
    payload: item,
  }),
  removeInventoryProvider: (id) => ({
    type: actions.REMOVE_INVENTORY_PROVIDER_REQUEST,
    payload: id,
  }),
  updateInventoryProvider: (id, item) => ({
    type: actions.UPDATE_INVENTORY_PROVIDER_REQUEST,
    payload: { id, item },
  }),
  fetchProviderHistory: (providerId) => ({
    type: actions.PROVIDER_HISTORY_FETCH_REQUEST,
    payload: providerId,
  }),
  clearProviderHistory: () => ({
    type: actions.PROVIDER_HISTORY_CLEAR,
  }),
  withdrawInventoryItem: (values) => ({
    type: actions.WITHDRAW_INVENTORY_ITEM_REQUEST,
    payload: values,
  }),
  updateInventoryDeposit: (values) => ({
    type: actions.UPDATE_INVENTORY_DEPOSIT_REQUEST,
    payload: values,
  }),
  cancelOperationRow: (id) => ({
    type: actions.CANCEL_OPERATION_REQUEST,
    payload: id,
  }),
  getInventoryOps: () => ({
    type: actions.INVENTORY_OPS_FETCH_REQUEST,
  }),
  reloadInventoryProviders: () => ({
    type: actions.INVENTORY_PROVIDERS_FETCH_REQUEST,
  }),
  updateInventoryWithdraw: (values) => ({
    type: actions.UPDATE_INVENTORY_WITHDRAW_REQUEST,
    payload: values,
  }),
  createInventoryClass: (item) => ({
    type: actions.CREATE_INVENTORY_CLASS_REQUEST,
    payload: item,
  }),
  removeInventoryClass: (item) => ({
    type: actions.REMOVE_INVENTORY_CLASS_REQUEST,
    payload: item,
  }),
  updateInventoryClass: (id, item) => ({
    type: actions.UPDATE_INVENTORY_CLASS_REQUEST,
    payload: { id, item },
  }),
  updateInventoryItem: (item) => ({
    type: actions.UPDATE_INVENTORY_ITEM_REQUEST,
    payload: item,
  }),
  updateFinalizedAppointmentProceduresArrFromInventoryRequest: (proceduresArr, totalItemsUsed, finalizeAppointment, warehouseId) => ({
    type: actions.UPDATE_FINALIZED_APPOINTMENT_PROCEDURES_ARR_FROM_INVENTORY_REQUEST,
    payload: {
      proceduresArr,
      totalItemsUsed,
      finalizeAppointment,
      warehouseId,
    },
  }),
  changeInventoryOpsListenerTime: (value, customValue = null, dateRange = null) => ({
    type: actions.CHANGE_INVENTORY_OPS_LISTENER_TIMER,
    payload: {
      value,
      customValue,
      dateRange,
    },
  }),
  saveItemSellValue: (value, itemId) => ({
    type: actions.SAVE_ITEM_SELL_VALUE_REQUEST,
    payload: {
      value,
      itemId,
    },
  }),
  createWarehouse: (values) => ({
    type: actions.CREATE_WAREHOUSE_REQUEST,
    payload: values,
  }),
  updateWarehouse: (id, values) => ({
    type: actions.UPDATE_WAREHOUSE_REQUEST,
    payload: { id, values },
  }),
  transferInventory: (values) => ({
    type: actions.TRANSFER_INVENTORY_REQUEST,
    payload: values,
  }),
  updateTransferInventory: (values) => ({
    type: actions.UPDATE_TRANSFER_INVENTORY_REQUEST,
    payload: values,
  }),
};

export default actions;
